<template>
 <section class="lock-settings" aria-labelledby="tcs-lock-title">
  <div class="lock-settings__heading">
   <div><h4 id="tcs-lock-title"><i class="el-icon-lock"></i> 锁系统</h4><p>锁屏时设置本次密码，解锁后自动清除</p></div>
   <el-switch :value="state.enabled" aria-label="启用锁系统" @change="toggle" />
  </div>
  <div v-if="state.enabled" class="lock-settings__actions"><span>快捷键 <kbd>Alt</kbd> + <kbd>L</kbd></span><el-button size="small" type="primary" icon="el-icon-lock" @click="lockNow">立即锁定</el-button></div>
  <p v-else>开启后可使用 Alt + L 快速锁屏</p>
  <p v-if="error" class="lock-settings__error" role="alert">{{ error }}</p>
 </section>
</template>
<script>
import { lockState, setLockEnabled, requestSystemLock, syncLockSession } from "@/utils/systemLock";
export default {
 name: "LockSettings",
 data: () => ({ state: lockState, error: "" }),
 created() { syncLockSession(); },
 methods: {
  toggle(enabled) { try { setLockEnabled(enabled); this.error = ""; } catch (error) { this.error = error.message; } },
  lockNow() { if (requestSystemLock()) this.$emit("locked"); }
 }
};
</script>
<style scoped>
.lock-settings { height: auto; margin: 20px 0; padding: 18px 0; border-top: 1px solid var(--app-border); border-bottom: 1px solid var(--app-border); }
.lock-settings__heading { display: flex; align-items: center; justify-content: space-between; gap: 16px; }
.lock-settings h4 { margin: 0; font-size: 14px; color: var(--app-text); }
.lock-settings p { margin: 8px 0 0; color: var(--app-text-secondary); font-size: 12px; line-height: 1.7; }
.lock-settings__actions { display: flex; flex-wrap: nowrap; align-items: center; gap: 8px; margin-top: 16px; }
.lock-settings__actions > span { flex: 1; font-size: 12px; color: var(--app-text-secondary); white-space: nowrap; }
.lock-settings kbd { padding: 3px 6px; border: 1px solid var(--app-border-strong); border-radius: 4px; background: var(--app-surface-muted); }
.lock-settings p.lock-settings__error { color: var(--app-danger, #e05252); }
</style>
